import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '../router.js';
Vue.use(Vuex);
export const strict = false;

export default new Vuex.Store({
  state: {
    preSelectedEmployment: '',
    spinner: false,
    pageData: window.pageObject,
    newData: window.pageObject.Steps,
    texts: '',
    payment: '',
    employment: 0,
    degree: 0,
    employmentTitle: '',
    enrollmentDate: '',
    studentEndPeriod: '',
    componentIsInvalid: false,
    regSet: false,
    accountSet: false,
    studentInsurance: '',
    studentInsuranceExtra: '',
    selectedHomeInsurance: '',
    selectedAccidentinsurance: '',
    acceptedInsurance: '',
    hasNoCPR: false,
    paymentType: '',
  },
  getters: {
    getAll: (state) => {
      return state.pageData.Steps;
    },
  },
  mutations: {
    setNewData(state, data) {
      const localData = sessionStorage.getItem('pageData');
      if (localData) {
        data = JSON.parse(localData);
      }
      state.newData = data;
      state.spinner = false;
      // Data localstorage
      // sessionStorage.setItem("pageData", JSON.stringify(data));
    },
    /**
     * Sets select options
     * @param {Object} params - All required parameters
     * @param {string} payload.component - Component to update
     * @param {Array} params.options - New options
     */
    setSelectOptions(state, params) {
      const { options, component } = params;
      state.newData.filter((item) => {
        if (item.Component === component) {
          item.Questions.map((question) => {
            if (options[question.QID]) {
              question.Options = options[question.QID];
            }
          });
        }
        state.spinner = false;
      });
    },

    /**
     * Sets city options
     * @param {Object} params - All required parameters
     * @param {string} payload.component - Component to update
     * @param {Array} params.options - New options
     */
    setCityOptions(state, params) {
      const { options, component } = params;
      state.newData.filter((item) => {
        if (item.Component === component) {
          item.Questions.map((question) => {
            if (options[question.QID]) {
              question.Options = options[question.QID];
            }
          });
        }
        state.spinner = false;
      });
    },
    /**
     * set employment/degree bound texts texts (header and description for welcome page
     * and consent popup)
     * @param {Object} params - All required parameters
     * @param {string} payload.component - Component to update
     * @param {Array} params.options - New options
     */
    setSelectText(state, params) {
      const { text } = params;
      this.state.texts = text;
      state.spinner = false;
    },
    setDegree: function (state, degree) {
      state.degree = degree;
    },
  },
  actions: {
    /**
     * Get welcometexts
     * @param {Object} payload - All required parameters
     * @param {string} payload.endpoint - Endpoint for getting study-direction options
     * @param {string} payload.component - Component to update
     * @param {Object} params.data - Post data
     * @returns post response
     */
    getEmploymentBoundTexts({ commit }, payload) {
      const { endpoint } = payload;
      axios
        .get(endpoint)
        .then((response) => {
          const text = JSON.parse(response.data.d);
          commit('setSelectText', {
            text,
          });
        })
        .catch(() => {
          router.push(window.errorPage.slug);
        });
    },

    /**
     * Get Select options
     * @param {Object} payload - All required parameters
     * @param {string} payload.endpoint - Endpoint for getting study-direction options
     * @param {string} payload.component - Component to update
     * @param {Object} params.data - Post data
     * @returns post response
     */
    getCityOptions({ commit }, payload) {
      const { endpoint, component } = payload;
      axios
        .post(endpoint)
        .then((response) => {
          const options = JSON.parse(response.data.d);
          commit('setCityOptions', {
            options,
            component,
          });
        })
        .catch(() => {
          router.push(window.errorPage.slug);
          // push router to errorpage empty All
        });
    },
    /**
     * Get Select options
     * @param {Object} payload - All required parameters
     * @param {string} payload.endpoint - Endpoint for getting study-direction options
     * @param {string} payload.component - Component to update
     * @param {Object} params.data - Post data
     * @returns post response
     */
    getSelectOptions({ commit }, payload) {
      const { endpoint, component, data } = payload;
      axios
        .post(endpoint, data)
        .then((response) => {
          const options = JSON.parse(response.data.d);
          commit('setSelectOptions', {
            options,
            component,
          });
        })
        .catch(() => {
          router.push(window.errorPage.slug);
          // push router to errorpage empty All
        });
    },
    doDegreeData({ commit }, degree) {
      commit('setDegree', degree);
    },
    doNewData({ commit, getters }, employment) {
      let newArray = getters.getAll;
      if (employment) {
        switch (employment) {
          case 1:
            this.state.employmentTitle = 'I Job';
            // I arbejde -> remove student, orlov
            // console.log("I arbejde -> remove student, orlov");
            newArray = getters.getAll.filter((element) => {
              if (
                element.SID === 0 ||
                element.SID === 1 ||
                element.SID === 2 ||
                element.SID === 4 ||
                element.SID === 6 ||
                element.SID === 8
              ) {
                return true;
              }
            });
            break;
          case 3:
            this.state.employmentTitle = 'Studerende';
            // Studerende -> remove uddannelse, arbejde, orlov
            // console.log("Studerende -> remove uddannelse, arbejde, orlov");
            if (this.state.hasNoCPR) {
              newArray = getters.getAll.filter((element) => {
                if (
                  element.SID === 0 ||
                  element.SID === 1 ||
                  element.SID === 3 ||
                  element.SID === 6 ||
                  element.SID === 8
                ) {
                  return true;
                }
              });
            } else {
              newArray = getters.getAll.filter((element) => {
                if (
                  element.SID === 0 ||
                  element.SID === 1 ||
                  element.SID === 3 ||
                  element.SID === 9 ||
                  element.SID === 6 ||
                  element.SID === 8
                ) {
                  return true;
                }
              });
            }
            break;
          case 4:
            this.state.employmentTitle = 'Orlov';
            // Orlov -> remove student, arbejde
            // console.log("Orlov -> remove student, arbejde");
            newArray = getters.getAll.filter((element) => {
              if (
                element.SID === 0 ||
                element.SID === 1 ||
                element.SID === 2 ||
                element.SID === 5 ||
                element.SID === 6 ||
                element.SID === 8
              ) {
                return true;
              }
            });
            break;
          default:
            newArray = getters.getAll.filter((element) => {
              if (
                element.SID === 0 ||
                element.SID === 1 ||
                element.SID === 2 ||
                element.SID === 6 ||
                element.SID === 8
              ) {
                return true;
              }
            });
        }
      }
      // store employment in state
      this.state.employment = employment;
      commit('setNewData', newArray);
    },
  },
});

